import ForgotPasswordForm from "../../components/Login/ForgotPasswordForm";


const ForgotPassword = () => {
  return (
    <div className="relative flex items-center justify-center w-full h-screen overflow-hidden">

      {/* Main background with gradient */}
      <div
        className="absolute inset-0"
        style={{
          background:
            " linear-gradient(180deg, rgb(16, 16, 24) 0%, 64.9979%, rgb(21, 48, 66) 79.9154%, 89.1379%, rgb(24, 78, 117) 100%)",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
          filter: "blur(-20px)",
        }}
      />

      {/* Content container */}
      <div className="relative z-10 container flex justify-center items-center overflow-hidden  px-4 sm:px-6 md:px-8">
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPassword;
